import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { StyleGoogleReviews, StyleGoogleReviewsItem, StyleInfoSection, StyleInfoSectionTripadvisorItem, StyleTripadvisor } from "../style";
import { TripadvisorLogoIcon } from "@/components/SvgIcons";
import Link from "next/link";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Trans, useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { devHosts } from "@/utils/utils";


const ListTralverReviews = [
  '"Hoi An Go electric car tour"',
  '"All in one go"',
  '"Tour in one go!"',
  '"Rice field trip"',
  '"VIETNAM FRIENDS TOUR FIRT EXPERIENCE"',
]

const InfoSection: React.FC = () => {
  const [currentHost, setCurrentHost] = useState('');

  const { t } = useTranslation("common");

  const tripadvisorStyleRef = useRef<HTMLDivElement>(null);
  const [isTripadvisorScriptLoaded, setIsTripadvisorScriptLoaded] = useState(false);

  const initializeTripadvisorStyles = () => {
    const container = document.querySelector('#TA_selfserveprop341 > div') as HTMLElement;

    if (container) {
      container.style.width = '100%';

      if (tripadvisorStyleRef.current) {
        tripadvisorStyleRef.current.style.border = '0px';
        tripadvisorStyleRef.current.style.borderRadius = '0px';
        tripadvisorStyleRef.current.style.padding = '0px';
      }
      setIsTripadvisorScriptLoaded(true);
    }
  };

  useEffect(() => {
    setCurrentHost(window.location.hostname);

    const tripadvisorWindow = window as Window & {
      taValIndex?: number;
      taValidate?: () => void;
    };
    const initialValidatorIndex = tripadvisorWindow.taValIndex ?? 0;

    // next/script only executes this third-party widget once. Re-inject it on
    // every mount so client-side navigation can initialize the new container.
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.jscache.com/wejs?wtype=selfserveprop&uniq=341&locationId=24922370&lang=en_US&rating=true&nreviews=5&writereviewlink=false&popIdx=true&iswide=false&border=true&display_version=2';
    script.dataset.loadtrk = 'true';
    document.body.appendChild(script);

    // Tripadvisor's loader registers the actual renderer as a window.onload
    // validator. window.onload has already fired during SPA navigation, so run
    // the newly registered validator explicitly and wait for its DOM output.
    let pollCount = 0;
    const tripadvisorPollTimer = window.setInterval(() => {
      pollCount += 1;

      if ((tripadvisorWindow.taValIndex ?? 0) > initialValidatorIndex) {
        tripadvisorWindow.taValidate?.();
        initializeTripadvisorStyles();
      }

      if (document.querySelector('#TA_selfserveprop341 > div') || pollCount >= 40) {
        window.clearInterval(tripadvisorPollTimer);
      }
    }, 250);

    // Execute Elfsight on every mount as well. A global next/script instance is
    // deduplicated, so it does not scan a new widget node after SPA navigation.
    const elfsightScript = document.createElement('script');
    elfsightScript.async = true;
    elfsightScript.src = 'https://static.elfsight.com/platform/platform.js';
    document.body.appendChild(elfsightScript);

    return () => {
      window.clearInterval(tripadvisorPollTimer);
      script.remove();
      elfsightScript.remove();
    };
  }, []);

  return (
    <>
      <StyleInfoSection id="info-section">
        {/* Tripadvisor Reviews */}
        <StyleInfoSectionTripadvisorItem>
          <Typography variant="h3" component="h3">
            {t("reviewInfoSection.customerReviews.title")}
          </Typography>
          <StyleTripadvisor
            ref={tripadvisorStyleRef}
            aria-label="Tripadvisor reviews card"
          >
            <div id="TA_selfserveprop341" className="TA_selfserveprop" style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <ul id="oxzhwwYs" className="TA_links ystUrQKSzHx">
                <li id="Y65n2ynhtek" className="I4JHqK7PG">
                  <Link
                    target="_blank"
                    href="https://www.tripadvisor.com/Attraction_Review-g298082-d24922370-Reviews-Hoi_An_GO-Hoi_An_Quang_Nam_Province.html"
                  >
                    <Image
                      src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-11900-2.svg"
                      alt="TripAdvisor"
                      width={136}
                      height={32}
                    />
                  </Link>
                </li>
              </ul>
            </div>
            {!isTripadvisorScriptLoaded ? <CircularProgress /> : null}
          </StyleTripadvisor>

        </StyleInfoSectionTripadvisorItem>

        {/* Google reviews */}
        <StyleGoogleReviewsItem>
          <Typography variant="h3" component="h3">
            {t("reviewInfoSection.googleReviews.title")}
          </Typography>
          {devHosts.some(host => currentHost.includes(host)) ? <Box sx={{ border: '1px solid #0185f0', borderRadius: '8px', width: '100%', height: '180px' }} />
            : (
              <StyleGoogleReviews
                className={process.env.NEXT_PUBLIC_GOOGLE_REVIEWS_ID}
                data-elfsight-app-lazy
              />
            )}
        </StyleGoogleReviewsItem>
      </StyleInfoSection >
    </>
  )
}

export default InfoSection;
